import { MapPin, Phone, Mail, MessageCircle, Clock } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { FullConsultationForm } from "../components/FullConsultationForm";
import { WHATSAPP_LINK, WHATSAPP_DISPLAY, EMAIL, COMPANY_LOCATION } from "../data/site";

export default function ContactUs() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Contact Us"
        title="Speak with a senior"
        italic="advisor"
        subtitle="Confidential enquiries only. We respond to every consultation request within one business day."
      />

      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4 space-y-4">
            {[
              { icon: MapPin, label: "Office", value: COMPANY_LOCATION },
              { icon: Phone, label: "Direct line", value: WHATSAPP_DISPLAY, href: `tel:+${"971567834333"}` },
              { icon: MessageCircle, label: "WhatsApp", value: WHATSAPP_DISPLAY, href: WHATSAPP_LINK, external: true },
              { icon: Mail, label: "Email", value: EMAIL, href: `mailto:${EMAIL}` },
              { icon: Clock, label: "Hours", value: "Sun – Thu · 09:00 – 19:00 GST" },
            ].map((c, i) => {
              const Icon = c.icon;
              const content = (
                <>
                  <div className="w-10 h-10 rounded-lg bg-[#c5a059]/15 flex items-center justify-center shrink-0">
                    <Icon size={16} className="text-[#c5a059]" />
                  </div>
                  <div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">{c.label}</div>
                    <div className="text-sm mt-1 break-all">{c.value}</div>
                  </div>
                </>
              );
              return c.href ? (
                <a
                  key={i}
                  href={c.href}
                  target={c.external ? "_blank" : undefined}
                  rel={c.external ? "noreferrer" : undefined}
                  className="glass rounded-xl p-4 flex items-start gap-3 hover:border-[#c5a059]/40 transition"
                  data-testid={`contact-${c.label.toLowerCase()}`}
                >
                  {content}
                </a>
              ) : (
                <div key={i} className="glass rounded-xl p-4 flex items-start gap-3" data-testid={`contact-${c.label.toLowerCase()}`}>
                  {content}
                </div>
              );
            })}
          </aside>

          <div className="lg:col-span-8">
            <div className="glass-strong rounded-2xl p-6 md:p-10">
              <div className="text-[10px] tracking-[0.4em] text-[#c5a059] uppercase mb-3">Consultation Request</div>
              <h2 className="font-serif-display text-3xl md:text-4xl mb-8">Tell us about your <em className="italic gold-gradient">requirements</em></h2>
              <FullConsultationForm />
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
